import { rpc } from "../../rpc";
import { clearMimicState, mimicState } from "../../stores/mimic";
import { IcoEye, IcoX } from "../icons";

/**
 * Banner shown at the top of the screen when an admin is mimicking another user.
 * Displays who is being mimicked and provides an exit button.
 */
export function MimicBanner() {
  const mimic = mimicState.value;

  if (!mimic) return null;

  async function handleExit() {
    if (!mimic) return;
    try {
      const workspaceId = mimic.workspaceId;
      await rpc.auth.stopMimic({});
      clearMimicState();
      // Navigate to members page where mimic workflow started
      window.location.href = `/orgs/${workspaceId}/members`;
    } catch (err) {
      console.error("Failed to exit mimic mode:", err);
      // Show user-facing error - the banner stays visible so they can retry
      alert("Failed to exit mimic mode. Please try again.");
    }
  }

  return (
    <div class="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 px-4 py-2">
      <div class="max-w-screen-xl mx-auto flex items-center justify-between">
        <div class="flex items-center gap-2">
          <IcoEye class="size-4" />
          <span class="font-medium">Viewing as {mimic.memberName}</span>
          <span class="text-amber-800 text-sm">(read-only)</span>
        </div>
        <button
          type="button"
          onClick={handleExit}
          class="flex items-center gap-1.5 px-3 py-1 bg-amber-600 hover:bg-amber-700 rounded text-sm font-medium transition-colors"
        >
          <IcoX class="size-3.5" />
          Exit
        </button>
      </div>
    </div>
  );
}
